import { ReactNode } from "react"
import BlocksConfigProvider, {
  BlocksConfigContextType
} from "../config/BlocksConfigProvider"
import GraphQLSyncer from "../syncer/GraphQLSyncer"
import { SyncerContextType, useSyncer } from "../syncer/SyncerContext"
import EditorStateProvider, { ESPTypes } from "./EditorStateProvider"

const EditorStateWithSyncer = ({ children }: { children: ReactNode }) => {
  const syncerState: SyncerContextType = useSyncer()

  return (
    <EditorStateProvider {...(syncerState as Omit<ESPTypes.Props, "children">)}>
      {children}
    </EditorStateProvider>
  )
}

export type BlocksEditContainerProps = BlocksConfigContextType & {
  children: ReactNode
  Syncer?: any
}

export const BlocksEditContainer = ({
  children,
  Syncer,
  ...config
}: BlocksEditContainerProps) => {
  const SyncProvider = Syncer || GraphQLSyncer

  const syncerProps: Record<string, any> = {}

  if (!Syncer) {
    syncerProps.graphQLClient = config.graphQLClient
    syncerProps.authToken = config.authToken
    syncerProps.graphQLEndpoint = config.graphQLEndpoint
    syncerProps.accountID = config.accountID
  }

  return (
    <BlocksConfigProvider {...config}>
      <SyncProvider {...syncerProps}>
        <EditorStateWithSyncer>{children}</EditorStateWithSyncer>
      </SyncProvider>
    </BlocksConfigProvider>
  )
}

export default BlocksEditContainer
